import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import { router } from './router.js'
import './assets/css/main.css'

const app = createApp(App)
const head = createHead()

app.use(head)
app.use(router)

app.mount('#app')
